module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bigBox2"
  }, [_c('section', {
    ref: "allHeight",
    staticClass: "publishHomeWork clear"
  }, [_vm._m(0), _vm._v(" "), (_vm.catalog.length) ? _c('article', {
    ref: "leftHeight",
    staticClass: "box menu"
  }, [_c('h4', {
    staticClass: "tip"
  }, [_vm._v("单元目录")]), _vm._v(" "), _c('ul', {
    staticClass: "first"
  }, _vm._l((_vm.catalog), function(unit, index) {
    return _c('li', {
      key: index,
      staticClass: "first_li",
      class: {
        'selectedUnit': unit.id == _vm.unitId && unit.children.length != 0, 'onlyUnit': unit.id == _vm.unitId && unit.children.length == 0
      }
    }, [_c('div', {
      staticClass: "gridUnit",
      on: {
        "click": function($event) {
          _vm.toggle(0, unit, [unit.id])
        }
      }
    }, [_c('p', {
      class: {
        'chooseUnit': unit.id == _vm.unitId, 'noChooseUnit': unit.id != _vm.unitId
      },
      attrs: {
        "title": unit.name
      }
    }, [_vm._v(_vm._s(unit.name))]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (unit.children.length != 0),
        expression: "unit.children.length!=0"
      }],
      staticClass: "icon arrow-icon",
      class: {
        'arrow-up': unit.id == _vm.unitId
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (unit.count > 0 && (!unit.checked || unit.children.length == 0)),
        expression: "unit.count>0 && (!unit.checked || unit.children.length == 0)"
      }],
      staticClass: "count_style"
    }, [_vm._v(_vm._s(unit.count))])]), _vm._v(" "), (unit.children.length) ? _c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (unit.checked),
        expression: "unit.checked"
      }],
      staticClass: "second"
    }, _vm._l((unit.children), function(page, cIndex) {
      return _c('li', {
        key: cIndex
      }, [_c('div', {
        staticClass: "gridPage",
        on: {
          "click": function($event) {
            _vm.toggle(1, page, [unit.id, page.id])
          }
        }
      }, [_c('p', {
        class: {
          'choosePage': page.id == _vm.pageId && page.children.length == 0, 'noChoosePage': page.id != _vm.pageId
        },
        attrs: {
          "title": page.name
        }
      }, [_vm._v(_vm._s(page.name))]), _vm._v(" "), _c('i', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (page.children != 0),
          expression: "page.children!=0"
        }],
        staticClass: "icon arrow-icon",
        class: {
          'arrow-down': page.id == _vm.pageId
        }
      }), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (page.count > 0 && (!page.checked || page.children.length == 0)),
          expression: "page.count>0 && (!page.checked || page.children.length == 0)"
        }],
        staticClass: "count_style"
      }, [_vm._v(_vm._s(page.count))])]), _vm._v(" "), (page.children.length) ? _c('ul', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (page.checked),
          expression: "page.checked"
        }],
        staticClass: "third"
      }, _vm._l((page.children), function(item, ccIndex) {
        return _c('li', {
          key: ccIndex
        }, [_c('div', {
          staticClass: "gridItem",
          class: {
            'chooseItem': item.id == _vm.itemId, 'noChooseItem': item.id != _vm.itemId
          },
          attrs: {
            "title": item.name
          },
          on: {
            "click": function($event) {
              _vm.toggle(2, item, [unit.id, page.id, item.id])
            }
          }
        }, [_vm._v("\n                      " + _vm._s(item.name) + "\n                      "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.count > 0),
            expression: "item.count > 0"
          }],
          staticClass: "count_style",
          staticStyle: {
            "right": "17px"
          }
        }, [_vm._v(_vm._s(item.count))])])])
      })) : _vm._e()])
    })) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "boxContent",
    staticClass: "box content"
  }, [_c('ul', _vm._l((_vm.module), function(item, sIndex) {
    return _c('li', {
      key: sIndex
    }, [_c('homeworkcontent', {
      attrs: {
        "moduleInfo": item.moduleInfo,
        "resourceList": item.resourceList,
        "checkedResource": item.checkedResource,
        "serviceId": _vm.serviceId,
        "packageId": _vm.packageId,
        "sIndex": sIndex,
        "cId": _vm.cId,
        "publishedBooks": _vm.publishedBooks
      },
      on: {
        "increment": _vm.increment
      }
    })], 1)
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.module.length == 0),
      expression: "module.length == 0"
    }],
    staticClass: "noModule"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/img/null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有可以布置的内容！")])])]), _vm._v(" "), _c('div', {
    staticClass: "box footers"
  }, [_c('span', [_c('span', {
    staticClass: "prev",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('span', {
    staticClass: "button",
    class: {
      'green': _vm.contents.length != 0, 'gray': _vm.contents.length == 0
    },
    on: {
      "click": _vm.subQuestion
    }
  }, [_vm._v("下一步")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectHead"
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("布置作业")]), _vm._v(" "), _c('div', {
    staticClass: "stepBar fr"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/step2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "active"
  }, [_vm._v("布置对象")]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v("选择内容")]), _vm._v(" "), _c('span', [_vm._v("作业留言")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57ad135c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publishHomeWork/publishHomeWork.vue
// module id = 1204
// module chunks = 1